import axios from 'axios';
import { apiRoutes } from '../../apiRoutes';
import { authHeader } from '../../global';

import Vue from 'vue'

const getDefaultStateForReceipts = () => {
  return {
    sales_receipts: [],
    purchase_receipts:[],
    data:{},
    filter:{
      keyword:"",
      date_from:null,
      date_to:null
    },
    is_created:null,
    is_updated:null,
    is_voided:null
  }
}


// state
const state = getDefaultStateForReceipts()
// getters
const getters = {

}

// mutations
const mutations = {
    RESET_STATE_FOR_RECEIPTS (state) {
        Object.assign(state, getDefaultStateForReceipts())
    },
    FETCH_ALL(state, { data, type })
    {
      if(data)
      {
        if(type == 'SALES')
        {
          data.forEach(function (element) {
              element.reference = (element.reference != null && element.reference != '') ? (element.reference): '-'
              element.is_void = (element.is_void == 1) ? 'YES' : 'NO'

          });
          state.sales_receipts = data
        }
        else if(type == 'PURCHASES')
        {
          state.purchase_receipts = data
        }

      }
    },
    FETCH(state, data) {
      state.data = data
    },
    SET_IS_CREATED(state, data){
      state.is_created = data
    },
    SET_IS_UPDATED(state, data){
      state.is_updated = data
    },
    SET_FILTER(state, data)
    {
      state.filter = data
    },
    SET_IS_VOID(state, data)
    {
      state.is_voided = data
    }
}

// actions
const actions = {
    resetState({ commit, dispatch }, payload) {
        commit("RESET_STATE_FOR_RECEIPTS")
    },
    async create({ commit, dispatch }, data) {
      let apiCreateSaleReceipt  = '';
      if(data['type'] == 'SALES')
        apiCreateSaleReceipt = apiRoutes['CREATE_SALE_RECEIPT']

      await axios.post(apiCreateSaleReceipt, data, authHeader())
          .then(function (response) {
            if(response.data.code == 1)
            {
              let doc_number  = response.data.data.code
              Vue.notify({
                  group: 'notify',
                  type: 'success',
                  text: 'Receipt (' + doc_number + ')' + " has been created!",
                  max: 5,
                  duration: 5000,
                  speed: 300
              })
  
              commit('SET_IS_CREATED', 1);
            }
            else
            {
                let errors = response.data.data.errors
                    
                if(Array.isArray(errors))
                {
                  let msg = errors.join("\n")
                  Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
                }
                commit('SET_IS_CREATED', 0);
            }
  
          })
          .catch((error) => {
              // alert(error)
              // console.log(error.response)
  
              if (error.response) {
                  //alert(error.response.data.message)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.message,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              }
              else
              {
                  //console.log("Problem submitting New Post", error);
                  alert("Application exception")
              }
          });
    },
    async update({ commit, dispatch }, data) {
      let apiUpdateSaleReceipt  = '';
      if(data['type'] == 'SALES')
      apiUpdateSaleReceipt = apiRoutes['UPDATE_SALE_RECEIPT']

      await axios.post(apiUpdateSaleReceipt, data, authHeader())
          .then(function (response) {
            if(response.data.code == 1)
            {
              let doc_number  = response.data.data.code
              Vue.notify({
                  group: 'notify',
                  type: 'success',
                  text: 'Receipt (' + doc_number + ')' + " has been updated!",
                  max: 5,
                  duration: 5000,
                  speed: 300
              })
  
              commit('SET_IS_UPDATED', 1);
            }
            else
            {
                let errors = response.data.data.errors
                    
                if(Array.isArray(errors))
                {
                  let msg = errors.join("\n")
                  Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
                }
                commit('SET_IS_UPDATED', 0);
              }
  
          })
          .catch((error) => {
              // alert(error)
              // console.log(error.response)
              commit('SET_IS_UPDATED', 0);

              if (error.response) {
                  //alert(error.response.data.message)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.message,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              }
              else
              {
                  //console.log("Problem submitting New Post", error);
                  alert("Application exception")
              }
          });
    },
    async void({ commit, dispatch }, data) {
      await axios.post(apiRoutes['VOID_RECEIPT'], data, authHeader())
          .then(function (response) {
            if(response.data.code == 1)
            {
              let doc_number  = response.data.data.code
              Vue.notify({
                  group: 'notify',
                  type: 'success',
                  text: 'Receipt (' + doc_number + ')' + " has been voided!",
                  max: 5,
                  duration: 5000,
                  speed: 300
              })
  
              commit('SET_IS_VOID', 1);
            }
            else
            {
                let errors = response.data.data.errors
                    
                if(Array.isArray(errors))
                {
                  let msg = errors.join("\n")
                  Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
                }
                commit('SET_IS_VOID', 0);
              }
  
          })
          .catch((error) => {
              // alert(error)
              // console.log(error.response)
              commit('SET_IS_VOID', 0);

              if (error.response) {
                  //alert(error.response.data.message)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.message,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              }
              else
              {
                  //console.log("Problem submitting New Post", error);
                  alert("Application exception")
              }
          });
    },
    quickSearch({ commit }, data) {
        return axios.post(apiRoutes['RECEIPTS_QUICK_SEARCH'], data, authHeader())
            .then(response => {
              if(response.data.code == 1)
              {
                commit('FETCH_ALL', {data:response.data.data, type:data.type})
                commit('SET_FILTER', data)
              } 
              else 
              {
                commit('FETCH_ALL', {data:[], type:null})
                commit('SET_FILTER', data)
              }
            })
            .catch(error => {
              if (error.response) {
                console.log(error.response)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              } else {
                  console.log("Problem Querying Data!", error);
              }
          });
    },
    fetch({ commit }, data) {
      let apiUrl = null;
        if(data.type == 'SALES')
        {
          apiUrl = apiRoutes['SALES_RETRIEVE_RECEIPT']
        }
        else if(data.type == 'PURCHASE')
        {
          //apiUrl = apiRoutes['SALES_RETRIEVE_ORDER']
        } 

        return axios.post(apiUrl, data, authHeader())
            .then(response => {
              if(response.data.code == 1){
                commit('FETCH', response.data.data)
              } else {
                commit('FETCH', {})
              }
            })
            .catch(error => {
              if (error.response) {
                console.log(error.response)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              } else {
                  console.log("Problem Querying Data!", error);
              }
          });
    },

}

export {
    state,
    getters,
    actions,
    mutations
}
